import React, { useContext } from "react";
import styled from "styled-components";
import LegacyBannerSection from "./LegacyBannerSection";
import LegacyHeader from "./LegacyHeader";
import LegacyFooter from "./LegacyFooter";
import { KBContext } from "../../Context";
import { CategoryLoader } from "../Loaders/CategoryLoader";
import AdminFooter from "../AdminFooter";
import { isFeatureEnabled } from "../../utils";
import { poweredByHiver } from "../../Constants";

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  min-height: 100vh;
  overflow: auto;
`;

const ContentArea = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
`;

export default function LegacyLayout(props) {
  const { data, showDashboardFooter, availableFeatures } = useContext(KBContext);
  const showPoweredByHiverFooter = isFeatureEnabled(poweredByHiver, availableFeatures);

  if (data) {
    return (
      <Wrapper tabIndex="-1" id="mainWrapper">
        <ContentArea>
          <LegacyHeader bannerData={data} />
          <LegacyBannerSection bannerData={data} />
          <div style={{ marginBottom: '40px' }}>
            {props.children}
          </div>
        </ContentArea>
        {showPoweredByHiverFooter && <LegacyFooter />}
        {showDashboardFooter ? <AdminFooter /> : ''}
      </Wrapper>
    );
  } else {
    return <CategoryLoader />;
  }
}
